/**
 * Most of this page (and the ConsultPdf component imported on View) is a copy
 * from bks-admin-ui's src/pages/consultPdf/consultPdf.page.tsx, adapted to
 * Stonking's differences. Please refer to the original files if necessary.
 */

import {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {useSelector} from 'react-redux'

import View from './view'

import {useAuth} from '../../components/AuthProvider'
import {toggleErrorDialog} from '../../redux/config'
import {useAppDispatch} from '../../redux/configureStore'
import {getConsultPdf, selectConsultPdf} from '../../redux/consult'

const ConsultPdf = () => {
  const {landingId} = useParams()

  const dispatch = useAppDispatch()
  const auth = useAuth()
  const pdf = useSelector(selectConsultPdf)

  const fetchConsultPdf = async () => {
    try {
      if (!landingId) {
        throw new Error(
          'Unable to fetch consult PDF: missing landingId on the URL',
        )
      }

      const {type} = await dispatch(getConsultPdf({auth, landingId}))

      if (type === getConsultPdf.rejected.type) {
        throw new Error('Unable to fetch Consult PDF')
      }
    } catch (e) {
      await dispatch(
        toggleErrorDialog({
          opened: true,
          error:
            'We were unable to fetch your consult PDF, please try reloading the page. If the issue persists contact our support team.',
        }),
      )
    }
  }

  useEffect(() => {
    fetchConsultPdf()
  }, [])

  return (
    <>
      <View landingId={landingId!} pdf={pdf} />
    </>
  )
}

export default ConsultPdf
